import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

@jsonObject
export class SystemStats {

  @jsonMember({name: 'uptime'})
  public Uptime!: number;

  @jsonArrayMember(Number, {name: 'cpuLoads'})
  public CPULoads!: number[];

  @jsonMember({name: 'processCount'})
  public ProcessCount!: number;
}

@jsonObject
export class RamStats {

  @jsonMember({name: 'total'})
  public Total!: number;

  @jsonMember({name: 'used'})
  public Used!: number;

  @jsonMember({name: 'free'})
  public Free!: number;

  @jsonMember({name: 'actualUsed'})
  public ActualUsed!: number;

  @jsonMember({name: 'actualFree'})
  public ActualFree!: number;
}

@jsonObject
export class MemStats {

  @jsonMember({name: 'total'})
  public Total!: number;

  @jsonMember({name: 'free'})
  public Free!: number;

  @jsonMember({name: 'used'})
  public Used!: number;
}

@jsonObject
export class Stats {

  @jsonMember({name: 'system'})
  public System!: SystemStats;

  @jsonMember({name: 'ram'})
  public RAM!: RamStats;

  @jsonMember({name: 'swap'})
  public Swap!: MemStats;

  @jsonMember({name: 'disk'})
  public Disk!: MemStats;
}
